import CalendarModel from "@/modules/calendar/core/models/CalendarModel";

class Promo {
    constructor({id, name, price, mode, active, image, config, calendar}) {
        this.className = 'PromoModel'
        this.id = id
        this.name = name
        this.image = image
        this.price = price
        this.mode = mode
        this.config = config
        this.active = active
        if(calendar){
            this.setCalendar(new CalendarModel(calendar))
        }

    }

    setCalendar(calendar) {
        if (calendar && calendar.className != "CalendarModel") {
            throw new Error("calendarTakeAway must be an instance of CalendarModel");
        }
        this.calendar = calendar;
    }

    /*
     * @returns {CalendarModel}
     */
    getCalendar() {
        return this.calendar;
    }

    isActive(datetime) {
        return this.active && (!this.calendar || (this.calendar && this.calendar.isActive(datetime)))
    }



}

export default Promo;
